export const Tag = ({ label }) => (
  <span className="bg-[#F1EDFF] text-gray-700 text-[9px] font-medium px-3 py-1 rounded-full whitespace-nowrap">
    {label}
  </span>
);
export const MatchRing = ({ value }) => {
  const r = 26,
    circ = 2 * Math.PI * r;
  const offset = circ - (value / 100) * circ;
  return (
    <div className="relative w-16 h-16 flex items-center justify-center flex-shrink-0">
      <svg width="68" height="68" className="absolute -rotate-90">
        <circle
          cx="34"
          cy="34"
          r={r}
          fill="none"
          stroke="#E8E8E8"
          strokeWidth="6"
        />
        <circle
          cx="34"
          cy="34"
          r={r}
          fill="none"
          stroke="#C9F8D3"
          strokeWidth="6"
          strokeDasharray={circ}
          strokeDashoffset={offset}
          strokeLinecap="round"
        />
      </svg>
      <div className="relative z-10 text-center leading-tight">
        <div className="text-[6px] text-gray-400 font-medium">Match</div>
        <div className="text-xs font-extrabold text-gray-900">{value}%</div>
      </div>
    </div>
  );
};
